import PromotionScope from './ScopeOld';

export default PromotionScope;
